import { Storage } from "aws-amplify";

export async function s3Upload(file) {
    //Since S3 doesn't allow upload of the same file name 
    // - (mobile take photo feature uses the same filename regardless of how many times a user take additional photos)
    // - create a unique filename in S3 that's <file-name>-<random number>.<file-ext>
    var randomNum = Math.floor((Math.random() * 10000) + 1);

    //Get the file name and extension separately
    const name = file.name;
    const lastDot = name.lastIndexOf('.');
    const fileName = name.substring(0, lastDot);
    const fileExt = name.substring(lastDot + 1);
    const today = getDateString();
    const filename = `${fileName}_${randomNum}_${today}.${fileExt}`;

    const stored = await Storage.vault.put(filename, file, {
        contentType: file.type,
    });

    return stored.key;
}

export async function s3PublicUpload(file, path) {
    //Since S3 doesn't allow upload of the same file name 
    // - (mobile take photo feature uses the same filename regardless of how many times a user take additional photos)
    // - create a unique filename in S3 that's <file-name>-<random number>.<file-ext>
    var randomNum = Math.floor((Math.random() * 10000) + 1);

    //Get the file name and extension separately
    const name = file.name;
    const lastDot = name.lastIndexOf('.');
    const fileName = name.substring(0, lastDot);
    const fileExt = name.substring(lastDot + 1);
    const today = getDateString();
    const filename = `${fileName}_${randomNum}_${today}.${fileExt}`;

    var bucket = '';
    if (path) {
        bucket = path;
    }

    const stored = await Storage.put(bucket + filename, file, {
        contentType: file.type,
        acl: 'public-read'
    });
    return stored.key;
}

export async function s3Get(key) {
    const file = await Storage.get(key, { expires: 600 });
    return file;
}

export async function s3GetWithBucket(key, bucket) {
    const file = await Storage.get(key, { expires: 600, bucket: bucket });
    return file;
}

export async function s3Delete(key) {
    await Storage.vault.remove(key);
    return;
}

export async function s3PublicDelete(key) {
    await Storage.remove(key);
    return;
}

export async function s3PublicDeleteWithBucket(key, bucket) {
    await Storage.remove(key, { bucket: bucket });
    return;
}

function getDateString() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    return yyyy+mm+dd;
}